import { useState, useEffect, useCallback } from 'react';
import { FigureModel } from '../models';
import {
  getAvatars,
} from '../providers/BasejumpApiProvider';

export default function useAvatars(basejumpToken, forDiscord = false) {
  const [isLoading, setIsLoading] = useState(false);
  const [avatars, setAvatars] = useState([]);

  const fetchAvatars = useCallback(async (silent = false) => {
    if (!silent) {
      setIsLoading(true);
    }
    try {
      if (basejumpToken) {
        const data = await getAvatars(basejumpToken);
        setAvatars([
           ...data.map(a => FigureModel.fromBasejumpAvatar(a, forDiscord))
        ]);
      }
    } catch (e) {
      setAvatars([]);
    } finally {
      setIsLoading(false);
    }
  }, [basejumpToken, forDiscord]);

  useEffect(() => {
    fetchAvatars();
  }, [basejumpToken, forDiscord]);

  return { avatars, isLoading, fetchAvatars };
}
